import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import Loading from 'src/components/Loading'
import { useOffer } from 'src/hooks/offer'
import { getSection } from 'src/hooks/useContentful/getSection'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import CardPlan from './CardPlan'
import contentfulClient from '../../../../services/contentful'
import * as S from './styles'
//import { Container, Plans, Title } from './styles'
import { useMemo } from 'react'
import Footer from './Footer'
import { addHours, isAfter, isToday } from 'date-fns'

function Planos() {
	const [loading, setLoading] = useState(false)
	const { setCurrentOffer } = useOffer()
	const content = useFetchContent()
	const promotionalCode = useMemo(
		() => content.data.fields.promotionalCodes.split('@')[0],
		[content.data.fields.promotionalCodes]
	)
	const hasCoupon = useMemo(() => content.data.fields.hasCoupon, [
		content.data.fields.hasCoupon
	])

	useEffect(() => {
		if (hasCoupon) setCurrentOffer(promotionalCode)
	}, [hasCoupon, promotionalCode, setCurrentOffer])

	const section = getSection({
		sectionName: 'landingDefaultPromo',
		data: content.data
	})

	const typePlans = ['pedagiosEstacionamentos', 'estacionamentos', 'pedagios']
	const plans = useQuery(
		'getCardPlan',
		() =>
			Promise.all(
				typePlans
					.filter(field => Object.keys(section).includes(field))
					.map(
						async field =>
							await contentfulClient.getEntry(section[field].sys.id)
					)
			),
		{
			enabled: content.data && !content.isLoading,
			retry: false
		}
	)

	useEffect(() => {
		setLoading(plans.isLoading || content.isLoading)
	}, [plans.isLoading, content.isLoading])

	if (loading || !plans.data) return <Loading />

	
	const adesaoText = () => {
		const bonusDay = addHours(new Date('2024-04-28'), 3)
		const today = addHours(new Date(), 3)
		const bonusIsToday = isToday(bonusDay)

		if(bonusIsToday) return 'Adesão grátis!'

		const isBonusAfter = isAfter(bonusDay, today)

		if(isBonusAfter) return "Taxa única de adesão de <strong>R$20</strong> por tag"

		return 'Adesão única de <strong>R$20</strong> por tag'
	}

	const newPlans = {
		data: [
			{
				fields: {
					benefits: [
						{
								"text": adesaoText(),
								"isBold": false
						},
						{
								"text": "Entrega grátis da tag",
								"isBold": false
						},
						{
								"text": "Recarga automática no cartão de crédito ou débito Bradesco. <span> Entenda o que é recarga automática {icon} </span>",
								"tooltip": {
									"title": "A recarga automática é uma facilidade para você nunca ficar sem saldo!",
									"description": "Você escolhe o valor para sua primeira recarga, a partir de R$50. Sempre que o saldo da conta chegar em 30%, nós recarregaremos automaticamente no cartão cadastrado."
								},
								"isBold": false
						},
						{
								"text": "A partir da segunda tag, a mensalidade será de R$14,90 por tag",
								"isBold": false
						}
				]
				}

			}
		]
	}

	return (
		<S.Container id="plans">
			<S.Title>{section.title}</S.Title>
			<S.Content>
				<S.Plans size={newPlans.data.length}>
					{newPlans.data?.map((plan, index) => (
						<CardPlan section={section} plans={newPlans} item={plan} key={index} />
					))}
				</S.Plans>
        <S.MainImage>
						<div>
							<div />
							<img src='/bradescoclassic/assets/planos_bradesco_classic.png' alt='Bradesco e smartphone'/>
						</div>
        </S.MainImage>
			</S.Content>
			<Footer
					buttonColor={plans.data[0].fields.corDoBotao}
					terms={section.regulamento}
					textColor={'#FFFFFF'}
					cupons={[
						plans.data[0].fields.firstButtonCoupon
					]}
					validade={plans.data[0].fields.validate}
				/>
		</S.Container>
	)
}
export default Planos
